document.addEventListener('DOMContentLoaded', function() {
    const cartForm = document.querySelector('form[action="/cart"]');
    if (cartForm) {
        cartForm.addEventListener('submit', function(event) {
            event.preventDefault();
            const submitButton = event.submitter;
            const isCheckout = submitButton && (submitButton.name === 'checkout' || submitButton.textContent.toLowerCase().includes('check'));
            if (isCheckout) {
                fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        let activeDiscount = '';
                        if (cart.discount_codes && cart.discount_codes.length > 0) {
                            const validCodes = cart.discount_codes.filter(dc => dc.applicable);
                            if (validCodes.length > 0) {
                                activeDiscount = validCodes[0].code;
                            }
                        }
                        let checkoutUrl = '/checkout';
                        if (activeDiscount) {
                            checkoutUrl = `/discount/${activeDiscount}?redirect=/checkout`;
                        }
                        window.location.href = checkoutUrl;
                    })
                    .catch(() => {
                        window.location.href = '/checkout';
                    });
            } else {
                this.submit();
            }
        });
    }
}); 